<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';

export default {
  mixins: [mixin],
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(this.$t('billing.zone_ppm.title'), this.mx_price(plan))}
            {this.mx_license(this.$t('billing.zone_ppm.one_time'), '')}
          </div>
        );
      });
    },
  },
};
</script>
